export var VisitPriority;
(function (VisitPriority) {
    VisitPriority["NORMAL"] = "normal";
    VisitPriority["HIGH"] = "high";
})(VisitPriority || (VisitPriority = {}));
